import React from 'react'
import { metaSetter } from '@app/utils'
import { Header, Header2 } from '@app/components/general/header'
import { MarketingDrawer } from '@app/components/general'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { blueLink } from '@app/components/stateless/typo/link-style'
import { companyName } from '@app/configs'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/playground',
    }),
  }
}

// NOT used anymore [deprecated.]
function Playground() {
  return (
    <MarketingDrawer>
      <SectionContainer className='py-10 space-y-1'>
        <div>
          <Header>{companyName} graphQL playground</Header>
          <p>
            The playground documentation is not available in the production
            version. To access the documentation, start the OSS version of
            <a
              href={'https://github.com/a11ywatch/a11ywatch'}
              className={blueLink}
              target='_blank'
              rel='noreferrer'
            >
              {companyName}
            </a>{' '}
            locally at this page.
          </p>
          <p className='text-gray-800 dark:text-gray-300'>
            You can integrate with our system in production by utilizing our
            Rest endpoints or by contacting our support team for instructions on
            the gRPC integration steps. If you decide to integrate using gRPC,
            you will need to connect with your IT team to whitelist instances
            that can connect to the system.
          </p>
        </div>
      </SectionContainer>
      <SectionContainer>
        <div className='py-2 pb-10'>
          <Header2>Need to use graphQL to integrate?</Header2>
          <p className='text-gray-800 dark:text-gray-300'>
            If you need to use graphQL to integrate please contact support or
            try to use a wrapper that can transform the request to POST.
          </p>
        </div>
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { Playground },
  {
    title: 'A11yWatch graphQL playground',
    description:
      'The GraphQL playground to test the A11yWatch endpoints and learn the schemas.',
  }
)
